import { ParameterType } from '@/study-search/enums';

import { Filter } from '../Filter';
import { IIndexation } from '../../../interfaces';
import { FilterKey } from '@studyportals/search-filters';

export class EducationLevelFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.EDUCATION_LEVEL, ParameterType.EDUCATION_LEVEL, []);
	}
}
